/** True if chat_icon should be rendered as an <img> src (http(s), data URL, or absolute image path). */
export function isChatIconImageUrl(s) {
  if (s == null || typeof s !== "string") return false;
  const t = s.trim();
  if (!t) return false;
  if (/^https?:\/\//i.test(t)) return true;
  if (/^data:image\//i.test(t)) return true;
  if (t.startsWith("/") && /\.(png|jpe?g|gif|webp|svg|bmp)(\?|#|$)/i.test(t)) return true;
  return false;
}

export function normalizeChatIcon(icon, fallback = "💬") {
  if (icon == null) return fallback;
  const t = String(icon).trim();
  return t || fallback;
}

/** When false, hide header and bot-message avatars. Defaults to enabled if unset. */
export function isChatIconEnabled(settings) {
  if (!settings || settings.chat_icon_enabled === undefined || settings.chat_icon_enabled === null) {
    return true;
  }
  return Boolean(settings.chat_icon_enabled);
}

